import { atom } from "jotai";
import { AccountDetailsState } from "./CampaignsTrendingDomains.types";

export const accountDetailsAtom = atom<AccountDetailsState | undefined>(
  undefined
);
